// src/portals/creator/components/MobileHeader.js
import React from "react";
import { Menu } from "lucide-react";
import { useAuth } from "../../../context/AuthContext";

const MobileHeader = ({ onMenuClick }) => {
  const { currentUser } = useAuth();

  return (
    <div className="sticky top-0 z-50 flex items-center justify-between p-4 bg-white border-b border-slate-200">
      <div className="flex items-center space-x-3">
        <img
          src={currentUser?.profilePictureUrl}
          alt={currentUser?.fullName}
          className="w-8 h-8 rounded-full object-cover"
        />
        <span className="font-bold text-slate-800">Dashboard</span>
      </div>
      <button onClick={onMenuClick} className="p-2">
        <Menu size={24} className="text-slate-600" />
      </button>
    </div>
  );
};

export default MobileHeader;
